// extracted by mini-css-extract-plugin
export default {"studded-image":"studded-image__studded-image___vak79"};